import alert from './AlertDialog';
import confirm from './ConfirmDialog';
import deny from './DenyDialog';
import documentHistory from './DocumentHistoryDialog';
import download from './DownloadDialog'
import information from './InformationDialog';
import recreate from './RecreateDialog';
import register from './RegisterDialog';
import search from './SearchDialog';

export default [alert, confirm, deny, download, documentHistory, information, recreate, register, search];